
import SnippetIndex from '@/components/snippets/Index.vue';
import Vue from 'vue';

Vue.component('snippets', SnippetIndex);

export default Vue.extend({});
